export interface Office {
    name: string;
    address: string;
    lat: number;
    lng: number;
    image?: string;
}

export const OFFICES: Office[] = [
    {
        name: 'Singapore',
        address: '21 Collyer Quay, Singapore 049320',
        lat: 1.2831,
        lng: 103.8513,
        image: '/images/Singapore.svg',
    },
    {
        name: 'San Francisco, USA',
        address: '415 Mission Street, San Francisco, CA 94105, USA',
        lat: 37.7897,
        lng: -122.3972,
        image: '/images/USA.svg',
    },
    {
        name: 'Bengaluru, India',
        address: 'Prestige Cube, Ground floor, Site, No. 26 Laskar, Hosur Rd, Adugodi, Bengaluru, Karnataka 560030',
        lat: 12.9363301,
        lng: 77.610998,
        image: '/images/Bangalore.svg',
    },
    {
        name: 'Hsinchu County, Taiwan',
        address: '復興三路二段, No. 168號, 復興三路, Zhubei City, Hsinchu County, Taiwan 30274',
        lat: 24.807675,
        lng: 121.038845,
        image: '/images/Taiwan.svg',
    },
];
